// extracted by mini-css-extract-plugin
module.exports = {"studentProgressBar":"styles_studentProgressBar__3v8u_"};